import PocketBase from 'pocketbase';

// Same origin in production (PocketBase serves the app); Vite proxies /api in dev.
export const pb = new PocketBase(import.meta.env.VITE_PB_URL || '/');

// Several components may load the same list at once; don't cancel each other.
pb.autoCancellation(false);
